export default __webpack_public_path__ + "static/media/hht1_ep08_timeline_q02_a.d461d32a.png";